import React from 'react';
import { connect } from 'react-redux';
import { formatDateDMA, fnMoneda } from '../tools';

const mapState = (state) => {
    return {
        "poliza": state.polizas.poliza
    }
}

class InformacionFinancieraPoliza extends React.Component {
    render() {
        let imgInfFinanciera;
        let resultado = this.props.poliza.informacionFinanciera.resultados[0];

        switch (this.props.poliza.generales.cveRamo) {
            case "G":
                imgInfFinanciera = require("../img/circle-cobranza.svg");
                break;
            case "D":
                imgInfFinanciera = require("../img/circle-poliza.svg");
                break;
            case "V":
                imgInfFinanciera = require("../img/circle-financiero.svg");
                break;
        }

        return <div className="card info-fin">
			<i><img src={ imgInfFinanciera } style={{"width":"57px"}} alt="" className="pad-right-10" /></i><span className="blue-text detalle-seccion">Información Financiera</span>
			<ul className="list-divider mt-25">
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Información Actualizada a</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="fechaActualizacion">{ formatDateDMA(resultado.fechaActualizacion) }</p>
						</div>
					</div>
				</li>
				{ resultado.tipoPolizaVida == "TRADICIONAL" &&
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Préstamo en la póliza</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="prestamoPoliza">$ { fnMoneda(resultado.prestamoPoliza) }</p>
						</div>
					</div>
				</li>
				}
				{ (resultado.tipoPolizaVida == "TRADICIONAL" || resultado.tipoPolizaVida == "FLEXIBLE") &&
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Valor en efectivo</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="valorEfectivo">$ { fnMoneda(resultado.valorEfectivo) }</p>
						</div>
					</div>
				</li>
				}
				{ resultado.tipoPolizaVida == "TRADICIONAL" &&
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Dotales a corto plazo</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="cveRamo">$ { resultado.importeDotalCortoPlazo ? resultado.importeDotalCortoPlazo : "0.00" }</p>
						</div>
					</div>
				</li>
				}
				{ resultado.tipoPolizaVida == "TRADICIONAL" &&
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Fondo en administración</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="cveRamo">$ { fnMoneda(resultado.fondoAdministrado) }</p>
						</div>
					</div>
				</li>
				}
				{ resultado.tipoPolizaVida == "TRADICIONAL" &&
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Saldo disponible</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="saldoDisponible">$ { fnMoneda(resultado.saldoDisponible) }</p>
						</div>
					</div>
				</li>
				}
				{ (resultado.tipoPolizaVida == "TRADICIONAL" || resultado.tipoPolizaVida == "FLEXIBLE") &&
				<p>De acuerdo con la última fecha de actualización, si decides cancelar tu póliza, el monto al que tienes derecho es de ${ fnMoneda(resultado.importeRetirable) }. Este monto podrá variar de acuerdo a la fecha en que se solicite la cancelación.</p>
				}
			</ul>
		</div>
    }
}

export default connect(mapState)(InformacionFinancieraPoliza);



// WEBPACK FOOTER //
// ./src/home/informacion-financiera.cmpt.js